module.exports = __webpack_public_path__ + "assets/1314819c88139524c2f47693a62d5f24.png";